const scoreEditrule = () => import('@/views/main/score/edit-rule/edit-rule.vue')
export default {
  path: '/main/score/scoreEditrule',
  name: 'scoreEditrule',
  component:  scoreEditrule,
  children: []
}
